import { GlobalAppState } from '@state/store';

export const getDealFinderLastSearchState = (state: GlobalAppState) => state.dealFinderLastSearched;
export const getDealFinderLastSearchType = (state: GlobalAppState) => state.dealFinderLastSearched.searchType;
export const getDealFinderLastSearchAirports = (state: GlobalAppState) => state.dealFinderLastSearched.airports;
